<script>
import { API_VILLAGE } from '../../common/api'
import VillageSelect from '../../components/VillageSelect'

export default {
  name: 'VillageAdd',
  data () {
    return {
      villageForm: {
        name: '',
        parent_id: '',
        admin_id: ''
      },
      rules: {
        name: [
          { required: true, message: '小区名不能为空', trigger: 'blur' }
        ],
        admin_id: [
          { required: true, message: '请选择抄表员', trigger: 'blur' }
        ],
      },
      selectVillageId: 0
    }
  },
  methods: {
    addVillage (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let params = this.villageForm
          params.parent_id = this.selectVillageId
          this.$http.POST(API_VILLAGE, params,
          res => {
            this.loading = false
            this.villageForm.name = ''
            this.villageForm.parent_id = ''
            this.villageForm.admin_id = ''
            this.$emit('addVillageSuccess')
          }, err => {
            this.loading = false
            this.villageForm.name = ''
            this.villageForm.parent_id = ''
            this.villageForm.admin_id = ''
            this.$message.error(err.msg)
          })
        }
      });
    },
    selectVillage (data) {
      this.selectVillageId = data
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  computed: {
    adminList () {
      return this.$store.state.village.adminList
    }
  },
  components: {
    VillageSelect
  }
}
</script>

<template>
  <div class="table_container">
    <el-form ref="villageForm" :model="villageForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
        <el-form-item label="小区名称" prop="name">
          <el-input v-model="villageForm.name" placeholder="请输入小区名" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="上级分类">
          <VillageSelect @selectVillageId='selectVillage' defaultVillageId=0 style="width: 300px"></VillageSelect>
        </el-form-item>
        <el-form-item label="抄表员" prop="admin_id">
          <el-select v-model="villageForm.admin_id" placeholder="请选择抄表员" style="width: 300px">
            <el-option
              v-for="item in adminList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="resetForm('villageForm')" size="small">重 置</el-button>
          <el-button type="primary" @click="addVillage('villageForm')" size="small">确 定</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/village/VillageAdd.vue